import React, { useMemo } from 'react'
import { TOpenModalDepartamentosFinanceiros } from '..'
import { useMutation, useQueryClient } from 'react-query';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { enqueueSnackbar } from 'notistack';
import axiosClient from '../../../../../../lib/axios';
import { Box, Button, CircularProgress, Dialog, DialogContent, DialogTitle, Grid, TextField } from '@mui/material';
import { IDataDepartamentosFinanceiros } from '../../../../../../types/api/financeiro/pesquisar-departamentos-financeiros';

export default function DialogCriacaoEditDepartamentos({
  defaultValue,
  open,
  handleClose
}: DialogCriacaoEditDepartamentosProps) {

  const queryClient = useQueryClient();

    const isEdit = useMemo(() => Boolean(defaultValue), [defaultValue])
    const valoresIniciais = useMemo(() => defaultValue?.defaultValue ? defaultValue?.defaultValue : null, [defaultValue])

    const methods = useForm<IDataDepartamentosFinanceiros>({
      defaultValues: {
        id: valoresIniciais?.id,
        nome: valoresIniciais?.nome || "",
      },
    })
    const { control, handleSubmit, getFieldState } = methods;

     //Querys e mutations
  const { mutate: criarDepartamento, isLoading: isLoadingCriarDepart } = useMutation({
      mutationKey: 'cadastrar-departamento',
      mutationFn: (inputs: any) => axiosClient.post("financeiro/configuracoes/cadastrar-departamento", inputs),
      onError: (error) => {
          console.error(error)
          enqueueSnackbar('Erro ao cadastrar departamento!', { variant: 'error' });
      },
      onSuccess: () => {
          queryClient.invalidateQueries(["pesquisar-departamentos"])
          handleClose()
          enqueueSnackbar('Cadastro de departamento realizado com sucesso!', { variant: 'success' });
      }
  })

  const { mutate: atualizarDepartamento, isLoading: isLoadingAttDepart } = useMutation({
      mutationKey: 'atualizar-departamento',
      mutationFn: (inputs: any) => axiosClient.put(`financeiro/configuracoes/atualizar-departamento/${valoresIniciais?.id}`, inputs),
      onError: (error) => {
          console.error(error)
          enqueueSnackbar('Erro ao atualizar departamento!', { variant: 'error' });
      },
      onSuccess: () => {
          queryClient.invalidateQueries(["pesquisar-departamentos"])
          handleClose()
          enqueueSnackbar('Atualização de departamento com sucesso!', { variant: 'success' });
      }
  })
  //

  //Funções manipuladoras
  const onSubmit = (data: IDataDepartamentosFinanceiros) => {
    const params = {
        nome: data.nome,
        id: data.id
    }
    if (isEdit) {
        atualizarDepartamento(params)
    }
    if (!isEdit) {
        criarDepartamento(params)
    }
}
//

  return (
    <FormProvider {...methods}>
    <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
    >
        <DialogTitle>
            {`${!isEdit ? "Adicionar" : "Editar"} departamento financeiro`}
        </DialogTitle>

        {
            (isLoadingAttDepart || isLoadingCriarDepart) &&
            <Box display="flex" justifyContent="center" mt={4} mb={8}>
                <CircularProgress />
            </Box>
        }

        {
            !isLoadingAttDepart && !isLoadingCriarDepart &&
            <>
                <Box
                    component={'form'}
                    onSubmit={handleSubmit(onSubmit)}
                >
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid size={{xs: 6}}>
                                    <Controller
                                        name="id"
                                        control={control}
                                        rules={{ required: 'Campo obrigatório' }}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                defaultValue={valoresIniciais?.id}
                                                label="Código*"
                                                variant="outlined"
                                                fullWidth
                                                type='number'
                                                error={getFieldState('id').invalid}
                                                helperText={getFieldState('id').error?.message || ""}
                                            />
                                        )}
                                    />
                            </Grid>
                            <Grid size={{xs: 6}}>
                                    <Controller
                                        name="nome"
                                        control={control}
                                        rules={{ required: 'Campo obrigatório' }}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                defaultValue={valoresIniciais?.nome}
                                                label="Nome*"
                                                variant="outlined"
                                                fullWidth
                                                error={getFieldState('nome').invalid}
                                                helperText={getFieldState('nome').error?.message || ""}
                                            />
                                        )}
                                    />
                            </Grid>
                        </Grid>
                        <Box mt={2} width={'100%'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} gap={2}>
                            <Button
                                onClick={handleClose}
                            >
                                Cancelar
                            </Button>
                            <Button
                                variant="contained"
                                type="submit"
                                autoFocus
                                disabled={isLoadingCriarDepart || isLoadingAttDepart}

                            >
                                {
                                    (isLoadingCriarDepart || isLoadingAttDepart) &&
                                    <CircularProgress size={20} sx={{ marginRight: 1 }} />
                                }
                                {!isEdit ? "Adicionar" : "Atualizar"}
                            </Button>
                        </Box>
                    </DialogContent>
                </Box>
            </>
        }
    </Dialog>
</FormProvider>
  )
}

interface DialogCriacaoEditDepartamentosProps {
    defaultValue: TOpenModalDepartamentosFinanceiros,
    open: boolean,
    handleClose: () => void
}
